import React from "react";
import ReactDOM from "react-dom/client";
import { Navigate, Route, HashRouter, Routes } from "react-router-dom";
import { AppShell } from "./shell/AppShell";
import { CompatPage } from "./routes/CompatPage";
import { TeacherEntryPage } from "./routes/TeacherEntryPage";
import { TeacherDashboardPage } from "./features/dashboard/TeacherDashboardPage";
import { ResultPage } from "./features/result/ResultPage";
import "./styles.css";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <HashRouter>
      <Routes>
        <Route element={<AppShell />}>
          <Route path="/compat" element={<CompatPage />} />
          <Route path="/t/:token" element={<TeacherEntryPage />} />
          <Route path="/r/:runId" element={<ResultPage />} />
          <Route path="/teacher/dashboard" element={<TeacherDashboardPage />} />
          <Route path="*" element={<Navigate to="/compat" replace />} />
        </Route>
      </Routes>
    </HashRouter>
  </React.StrictMode>
);
